<div class="rangebox">
    <button data-target="#collapsecabin" data-toggle="collapse" class="collapsebtn" type="button">Cabin Class</button>
    
    
        <div id="collapsecabin" class="collapse show">
            <div class="boxins">
                <ul class="locationul">
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="farecheckbox" id="squaredThree5">
                            <label for="squaredThree5"></label>
                        </div>
                        <label class="llbl" for="squaredThree5">Economy</label>
                    </li>
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="farecheckbox" id="squaredThree6">
                            <label for="squaredThree6"></label>
                        </div>
                        <label class="llbl" for="squaredThree6">Business</label>
                    </li>
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="farecheckbox" id="squaredThree7">
                            <label for="squaredThree7"></label>
                        </div>
                        <label class="llbl" for="squaredThree7">First Class</label>
                    </li>
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="farecheckbox" id="squaredThree8">
                            <label for="squaredThree8"></label>
                        </div>
                        <label class="llbl" for="squaredThree8">Premium Economy</label>
                    </li>
              </ul>
            </div>
        </div>
    
</div>

